import postRequest from 'utils/postRequest'
import getRequest from 'utils/getRequest'
import deleteRequest from 'utils/deleteRequest'
import { editOnly } from 'routing/constants'

const path = '/api/site-reviewer'
const reassessmentPath = '/api/reassessment/sites'
const editSitePath = '/api/editSite/sites'


export const requestGetPotentialSiteReviewers = ({excludeIds = [], searchQuery = '', siteId}, siteHistoryId) => {
  const url = siteHistoryId ? `${reassessmentPath}/reviewers` : `${path}/`
  return postRequest(url, {excludeIds, searchQuery, siteId})
}

export const requestAddNewSiteReviewer = ({siteId, newReviewers = []}, siteHistoryId) => {
  const url = siteHistoryId ? `${reassessmentPath}/${siteHistoryId}/reviewers` : `${path}/${siteId}`
  return postRequest(url, {newReviewers})
}

export const requestRemoveSiteReviewer = (reviewerId, siteHistoryId) => {
  const url = siteHistoryId ? `${reassessmentPath}/${siteHistoryId}/reviewers/${reviewerId}` : `${path}/${reviewerId}`
  return deleteRequest(url)
}

export const requestGetSiteReviewers = (siteId, siteHistoryOrEditOnlyId, paths = null) => {
  const url = paths === editOnly ? `${editSitePath}/${siteHistoryOrEditOnlyId}/reviewers` : siteHistoryOrEditOnlyId ? `${reassessmentPath}/${siteHistoryOrEditOnlyId}/reviewers` : `${path}/${siteId}`
  return getRequest(url)
}
